export type EmailSystem = 'shop' | 'qg'

/** Valor legado do enum (antes da renomeação pasi_shop → shop). */
export type EmailSystemLegacy = 'pasi_shop'

export function normalizeEmailSystem(
  value: string | null | undefined
): EmailSystem {
  if (value === 'shop' || value === 'pasi_shop') return 'shop'
  if (value === 'qg') return 'qg'
  return 'shop'
}

export interface EmailTemplate {
  id: number
  subject: string
  sender: string
  system: EmailSystem
  html_storage_path: string
  obs?: string | null
  created_at: string
  updated_at: string
  created_by?: string | null
  deleted_at?: string | null
  deleted_by?: string | null
}

export const EMAIL_SYSTEM_LABELS: Record<EmailSystem, string> = {
  shop: 'PASI Shop',
  qg: 'QG',
}

export const EMAIL_SYSTEM_OPTIONS: { value: EmailSystem; label: string }[] = [
  { value: 'shop', label: EMAIL_SYSTEM_LABELS.shop },
  { value: 'qg', label: EMAIL_SYSTEM_LABELS.qg },
]
